<template lang="pug">
	.editor-control-range-double(:class="{'change-process': changedValue !== null, [theme]: true}")
		.input-title(v-if="title") {{title}}
		.number-inputs(v-if="!noInput")
			label
				input.form-control.form-control-sm(
					:value="getDisplayedMinValue()"
					v-on:keyup="changeMinValueByInput($event.target.value, $event, false)"
					v-on:change="changeMinValueByInput($event.target.value, $event)"
					v-on:focus="blockUpdate()"
					v-on:blur="unblockUpdate()"
				)
			span.number-separator -
			label
				input.form-control.form-control-sm(
					:value="getDisplayedMaxValue()"
					v-on:keyup="changeMaxValueByInput($event.target.value, $event, false)"
					v-on:change="changeMaxValueByInput($event.target.value, $event)"
					v-on:focus="blockUpdate()"
					v-on:blur="unblockUpdate()"
				)
		.range-double-container
			.range-track-bg
			.range-track-fill(:style="fillTrackStyle")
			input.custom-range.range-slider-thumb(
				type="range"
				:value="getMinValue()"
				:min="getMinLimit()"
				:max="getMaxLimit()"
				:step="getStep()"
				v-on:input="onMinSliderInput($event.target.value)"
			)
			input.custom-range.range-slider-thumb(
				type="range"
				:value="getMaxValue()"
				:min="getMinLimit()"
				:max="getMaxLimit()"
				:step="getStep()"
				v-on:input="onMaxSliderInput($event.target.value)"
			)
</template>

<script>

	import Screen 							from './../../../mixins/screen';

	export default {
		name: 'InputRangeDouble',
		mixins: [Screen],
		screen: {
			updateOn: [],
			events: {}
		},
		components: {},
		props: {
			'title': String,
			'default': Array,
			'value': Array,
			'min': Number,
			'max': Number,
			'step': Number,
			'options': Object,
			'theme': String,
			'noInput': Boolean
		},
		data() {

			return {
				showed: true,
				changedValue: null
			};

		},
		computed: {
			fillTrackStyle() {

				let minLimit = this.getMinLimit(),
					maxLimit = this.getMaxLimit(),
					range = maxLimit - minLimit;

				if (range <= 0) return { left: '0%', width: '100%' };

				let [minVal, maxVal] = this.getValue();
				let leftPercent = Math.max(0, Math.min(100, ((minVal - minLimit) / range) * 100));
				let rightPercent = Math.max(0, Math.min(100, ((maxVal - minLimit) / range) * 100));
				let widthPercent = Math.max(0, rightPercent - leftPercent);

				return {
					left: `${leftPercent}%`,
					width: `${widthPercent}%`
				};

			}
		},
		methods: {
			collectData() {

			},
			getMinLimit() {

				if (this.options?.controlOptions?.min !== undefined) return parseFloat(this.options.controlOptions.min);
				if (this.options?.changes?.min !== undefined) return parseFloat(this.options.changes.min);
				if (this.min !== undefined) return parseFloat(this.min);
				return 0.1;

			},
			getMaxLimit() {

				if (this.options?.controlOptions?.max !== undefined) return parseFloat(this.options.controlOptions.max);
				if (this.options?.changes?.max !== undefined) return parseFloat(this.options.changes.max);
				if (this.max !== undefined) return parseFloat(this.max);
				return 10;

			},
			getStep() {

				if (this.options?.controlOptions?.step !== undefined) return parseFloat(this.options.controlOptions.step);
				if (this.options?.changes?.step !== undefined) return parseFloat(this.options.changes.step);
				if (this.step !== undefined) return parseFloat(this.step);
				return 0.1;

			},
			getAccuracy() {

				if (this.options?.changes?.accuracy !== undefined) return this.options.changes.accuracy;
				let step = this.getStep();
				let stepStr = step.toString();
				if (stepStr.indexOf('.') !== -1) return stepStr.split('.')[1].length;
				return 1;

			},
			getValue() {

				let value = null;

				if (this.changedValue !== null && this.changedValue !== undefined) value = this.changedValue;
				else if (this.value !== null && this.value !== undefined) value = this.value;
				else if (this.default !== null && this.default !== undefined) value = this.default;
				else value = [this.getMinLimit(), this.getMaxLimit()];

				return this.restoreValueType(value);

			},
			getMinValue() {

				return this.getValue()[0];

			},
			getMaxValue() {

				return this.getValue()[1];

			},
			getDisplayedMinValue() {

				let minVal = this.getMinValue();
				let accuracy = this.getAccuracy();
				return parseFloat(minVal.toFixed(accuracy));

			},
			getDisplayedMaxValue() {

				let maxVal = this.getMaxValue();
				let accuracy = this.getAccuracy();
				return parseFloat(maxVal.toFixed(accuracy));

			},
			restoreValueType(value) {

				let minLimit = this.getMinLimit();
				let maxLimit = this.getMaxLimit();

				if (!Array.isArray(value)) value = [minLimit, maxLimit];

				let minVal = parseFloat(value[0]);
				let maxVal = parseFloat(value[1]);

				if (isNaN(minVal)) minVal = minLimit;
				if (isNaN(maxVal)) maxVal = maxLimit;

				if (minVal < minLimit) minVal = minLimit;
				if (minVal > maxLimit) minVal = maxLimit;
				if (maxVal < minLimit) maxVal = minLimit;
				if (maxVal > maxLimit) maxVal = maxLimit;

				if (minVal > maxVal) {
					let temp = minVal;
					minVal = maxVal;
					maxVal = temp;
				}

				return [minVal, maxVal];

			},
			setValue(value) {

				this.changedValue = this.restoreValueType(value);

				this.$emit('input', this.changedValue);

				clearTimeout(this.sendTimeout);
				this.sendTimeout = setTimeout(() => {

					this.$emit('change', this.changedValue);

					clearTimeout(this.sendTimeout);
					this.sendTimeout = setTimeout(() => {

						this.changedValue = null;
						this.update();

					}, 300);

				}, 500);

			},
			onMinSliderInput(val) {

				val = parseFloat(val);
				let maxVal = this.getMaxValue();
				if (val > maxVal) val = maxVal;
				this.setValue([val, maxVal]);

			},
			onMaxSliderInput(val) {

				val = parseFloat(val);
				let minVal = this.getMinValue();
				if (val < minVal) val = minVal;
				this.setValue([minVal, val]);

			},
			changeMinValueByInput(value, e = null) {

				if (parseFloat(value) + '' !== value) return;
				let parsed = parseFloat(value);
				if (!isNaN(parsed)) {
					let maxVal = this.getMaxValue();
					if (parsed > maxVal) parsed = maxVal;
					this.setValue([parsed, maxVal]);
				}

			},
			changeMaxValueByInput(value, e = null) {

				if (parseFloat(value) + '' !== value) return;
				let parsed = parseFloat(value);
				if (!isNaN(parsed)) {
					let minVal = this.getMinValue();
					if (parsed < minVal) parsed = minVal;
					this.setValue([minVal, parsed]);
				}

			},
			blockUpdate() {

				this.updateBlocked = true;

			},
			unblockUpdate() {

				this.updateBlocked = false;

				clearTimeout(this.updateTimeout);
				this.updateTimeout = setTimeout(() => {

					this.update();

				}, 200);

			}
		}

	};
</script>

<style lang="sass">

	.editor-control-range-double
		color: #f3f4f5
		display: flex
		flex-direction: row
		flex-wrap: nowrap
		align-items: center

		.input-title
			display: flex
			justify-content: right
			overflow: hidden
			text-overflow: ellipsis
			color: var(--secondary)
			font-size: 0.85rem
			padding-right: 0.5rem
			cursor: default
			user-select: none

		.number-inputs
			display: flex
			flex-direction: row
			flex-wrap: nowrap
			align-items: center

			.number-separator
				padding: 0 4px
				color: var(--secondary)
				font-size: 0.8rem

			label
				display: flex
				flex-direction: row
				flex-wrap: nowrap
				margin: 0
				padding: 0

			input
				margin: 0
				box-shadow: none
				outline: none !important
				border-radius: 0.1rem
				color: rgba(255, 255, 255, 0.87)
				background-color: rgba(255, 255, 255, 0.05)
				border: 1px solid rgba(255, 255, 255, 0.09)
				padding: 0 3px
				text-align: center

		.range-double-container
			position: relative
			margin-left: 10px
			margin-top: 1px
			width: 120px
			height: 24px
			display: flex
			align-items: center

			.range-track-bg
				position: absolute
				left: 0
				right: 0
				height: 3px
				background-color: rgba(255, 255, 255, 0.09)
				border-radius: 2px

			.range-track-fill
				position: absolute
				height: 3px
				background-color: rgba(0,0,0,0.4)
				border-radius: 2px
				z-index: 1

			.range-slider-thumb
				position: absolute
				left: 0
				width: 100%
				height: 3px
				margin: 0
				padding: 0
				background: transparent
				-webkit-appearance: none
				-moz-appearance: none
				appearance: none
				pointer-events: none
				z-index: 2

				&::-webkit-slider-runnable-track
					background: transparent
					border: none
					height: 3px

				&::-moz-range-track
					background: transparent
					border: none
					height: 3px

				&::-webkit-slider-thumb
					-webkit-appearance: none
					appearance: none
					width: 10px
					height: 10px
					border-radius: 50%
					background-color: #383d47
					border: 1px solid rgba(0,0,0,0.2)
					cursor: pointer
					pointer-events: auto
					box-shadow: none
					margin-top: -3.5px

				&::-moz-range-thumb
					width: 10px
					height: 10px
					border-radius: 50%
					background-color: #383d47
					border: 1px solid rgba(0,0,0,0.2)
					cursor: pointer
					pointer-events: auto
					box-shadow: none

	.editor-control-range-double.dark-mini
		min-height: 31px

		.number-inputs
			input
				width: 44px
				height: 24px
				font-size: 0.8rem

		.range-double-container
			width: 100px

	.editor-control-range-double.dark-medium
		.number-inputs
			input
				width: 50px
				height: 30px
				font-size: 14px

		.range-double-container
			width: 120px

	.editor-control-range-double.change-process
		.input-title
			color: #20a8d8

		.range-double-container

			.range-track-fill
				background-color: #20a8d8

			.range-slider-thumb::-webkit-slider-thumb
				border: 1px solid #20a8d8

			.range-slider-thumb::-moz-range-thumb
				border: 1px solid #20a8d8

</style>
